var render = function render() {
  var _vm$devicesInfo$micro;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "audioCheck"
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": _vm.returnClass,
      "effect": "dark",
      "placement": "top",
      "value": _vm.visiable,
      "manual": _vm.returnManual
    }
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_vm.mic && (_vm$devicesInfo$micro = _vm.devicesInfo.microphoneList) !== null && _vm$devicesInfo$micro !== void 0 && _vm$devicesInfo$micro.length ? _c('div', {
    on: {
      "click": function ($event) {
        return _vm.setMic(false);
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-a-V2micon"
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.osLevelmicMuted,
      expression: "osLevelmicMuted"
    }],
    staticClass: "el-icon-warning"
  })]) : _c('i', {
    staticClass: "iconfont icon-a-V2micoff",
    on: {
      "click": function ($event) {
        return _vm.setMic(true);
      }
    }
  })]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.mic || !_vm.showCheckTips ? _c('div', [_vm._v(_vm._s(_vm.showDeviceTips('microphone', _vm.mic, _vm.devicesInfo)))]) : _c('div', [_c('header', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "head-left"
  }, [_c('i', {
    staticClass: "iconfont icon-mic"
  }), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.youMute')))])]), _c('div', {
    staticClass: "head-right"
  }, [_c('i', {
    staticClass: "iconfont icon-close pointer",
    on: {
      "click": _vm.close
    }
  })])]), _c('section', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.$t('common.checkAudioMsg')))])])])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };